var map = {
	"./Template Import MCR Items - ANTAM MCR001.xlsx": 7960,
	"./Template Import MCR Items - ANTAM MCR002.xlsx": 9925,
	"./Template Import MCR Items - INALUM MCR001.xlsx": 9687,
	"./Template Import MCR Items - INALUM MCR002.xlsx": 5182,
	"./Template Import MCR Items - INALUM MCR003.xlsx": 8421,
	"./Template Import MCR Items - INALUM MCR004.xlsx": 9572,
	"./Template Import MCR Items - INALUM MCR005.xlsx": 2899,
	"./Template Import MCR Items - INALUM MCR008.xlsx": 2643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4412;